namespace TabAurous.Retail {
    export namespace TopCollectionsService {
        export const baseUrl = 'POSSales/TopCollections';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/TopCollections/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopCollectionsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
